const quickView = ({ language, isSavedUser }) => {
  return {
    title: "Quick View",
    url: "https://chrome.google.com/webstore/detail/amazon-quick-view-by-amzs/pggamokfileohlopdonjmelbbghhnlah?utm_source=site&utm_medium=amzscout&utm_campaign=footer",
    target: true,
    ref: true,
    isLink: false,
  };
};

export default quickView;
